var _defs, _path, _rect, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.65 130.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 4px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-linejoin: bevel;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.65,65.32c0,34.97-28.35,63.33-63.33,63.33S2,100.3,2,65.32,30.35,2,65.32,2s63.33,28.35,63.33,63.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.07,
    y: 33.08,
    width: 64.5,
    height: 64.5,
    rx: 15.84,
    ry: 15.84
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 65.32,
    cy: 65.33,
    r: 16.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 84.95,
    cy: 46.33,
    r: 4.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlInsta);
export default __webpack_public_path__ + "static/media/DL-Insta.84672de9f8bbc52d68c6593e4ea5c705.svg";
export { ForwardRef as ReactComponent };